import {
    Card,
    CardContent,
    Divider,
    Grid,
    Typography,
    Container,
    Dialog,
    DialogTitle,
    IconButton,
} from '@mui/material'
import styled from '@emotion/styled'
import { Close } from '@mui/icons-material';


function BusinessInfoDrawer({
    visible,
    title,
    cancelText,
    initialValues,
    onClose
}) {

    if (initialValues == undefined)
        initialValues = {
            name: '',
            gstn: '',
            telephone: '',
            fax: '',
            cin: '',
            address: '',
            city: '',
            pin: '',
            state: '',
            country: '',
            multi_outlet: false,
        }

    return (
        <>
            <Dialog maxWidth='sm' fullWidth anchor='right' backdrop='static' variant="temporary" open={visible} onClose={onClose}>
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Divider my={2} />
                <Container sx={{ padding: 2, }} >
                    <Card>
                        <CardContent>
                            <Grid container spacing={1} direction="column">
                                <Grid item>
                                    <Grid container sx={{ justifyContent: 'space-between' }}>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Name
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.name}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Telephone
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.telephone}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Business Code
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.business_code}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider sx={{ marginTop: 2 }} />
                                <Grid item>
                                    <Grid container sx={{ justifyContent: 'space-between', paddingTop: 5 }}>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    GSTN
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.gstn ?? "-"}
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Fax
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.fax ?? "-"}
                                                </Typography>


                                            </Grid>
                                        </Grid>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    CIN
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.cin ?? "-"}
                                                </Typography>
                                            </Grid>
                                        </Grid>


                                    </Grid>
                                </Grid>
                                <Divider sx={{ marginTop: 2 }} />
                                <Grid item>
                                    <Grid container sx={{ justifyContent: 'space-between', paddingTop: 5 }}>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    City
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.city}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    State
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.state}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    Country
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.country}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item >
                                            <Grid container alignItems="center" direction="column">
                                                <Typography style={{ fontSize: 12, color: '#065656' }}>
                                                    PinCode
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        color: '#065656',
                                                    }}
                                                >
                                                    {initialValues.pin ?? "-"}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
            </Dialog>
        </>
    );
}

export default BusinessInfoDrawer;